import { FormFieldConfig } from 'components/FormBuilder/FormBuilder'

export type PreRegisForm = {
  firstName?: string
  lastName?: string
  age?: number
  email?: string
  phoneNumber?: string
  nationalId?: string
}

export const formFieldsConfig: FormFieldConfig<PreRegisForm> = {
  firstName: {
    fieldName: 'firstName',
    label: 'First Name',
    validationType: 'engChrOnly',
    isRequired: true,
  },
  lastName: {
    fieldName: 'lastName',
    label: 'Last Name',
    validationType: 'engChrOnly',
    isRequired: true,
  },
  email: {
    fieldName: 'email',
    label: 'Email',
    validationType: 'email',
    isRequired: true,
  },
  phoneNumber: {
    fieldName: 'phoneNumber',
    label: 'Phone Number',
    validationType: 'numberOnly',
    isRequired: true,
  },
}

export const defaultValues: PreRegisForm = {}
